//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import CreditNote from "@/views/creditNote/CreditNote.vue"
import SlSaleCreditNoteList from '@/views/Sale/SlSaleCreditNote/list'

//
export default {
  path: "sale_credit_note",
  component: ModuleLayout,
  children: [
    {
      path: "",
      name: "sale-credit-note",
      component: SlSaleCreditNoteList,
    },
    {
      path: "create",
      name: "sale-credit-note-create",
      component: CreditNote,
      meta: {
        title: "Crear nota de débito"
      },
    },
    // {
    //     path: ":id",
    //     name: "sale-debit-note-update",
    //     component: SaleDebitNoteUpdate,
    //     meta: {
    //         title: "Detalles de nota de débito"
    //     },
    // },
  ],
  meta: {
    title: "Notas de crédito",
  }

}